import { ProductMin, Subscription } from '@src/types.ts'

export const shouldShowVideoCalls = (
  subscriptions: (Pick<Subscription, 'id'> & {
    primaryProduct: Pick<ProductMin, 'bundledPaidCalls'>
  })[],
) => {
  return !subscriptions.some((subscription) => subscription.primaryProduct.bundledPaidCalls)
}
